define('plugins/musicfavourite/nls/default/dialog',{
    'en-gb': {
        'upsell': {
            'heading': 'Sign in to add this to your Favourites',
            'text': 'Signing in lets you use your Favourites to keep track of the stuff you love on any device.',
            'signIn': 'Sign in',
            'signInText1': ' with your BBC iD',
            'signInText2': 'or',
            'signInText3': 'Register',
            'signInText4': 'It&rsquo;s fast and free.'
        },
        'limited': {
            'heading': 'Sorry, you’ve reached the limit'
        }
    },
    'cy-gb': { //WELSH
        'upsell': {
            'heading': 'Mewngofnodi i ychwanegu hwn i&rsquo;ch ffefrynnau',
            'text': 'Mae mewngofnodi yn eich galluogi i ddefnyddio&rsquo;ch Ffefrynnau i gadw golwg ar y cynnwys rydych yn ei hoffi ar unrhyw ddyfais.',
            'signIn': 'Mewngofnodwch',
            'signInText1': ' gyda&rsqo;ch BBC iD',
            'signInText2': 'neu',
            'signInText3': 'Gofrestrwch',
            'signInText4': 'Mae&rsquo;n gyflym ac yn rhad.'
        }
    },
    'ga-gb': { //IRISH
        'upsell': {
            'heading': 'S&iacute;nigh isteach chun &eacute; seo a chur le Mo Chean&aacute;in',
            'text': 'M&aacute; sh&iacute;neann t&uacute; isteach is f&eacute;idir leat Mo Chean&aacute;in a &uacute;s&aacute;id leis na ruda&iacute; is ansa leat a aimsi&uacute; ar ghl&eacute;as ar bith.',
            'signIn': 'S&iacute;nigh isteach',
            'signInText1': ' ag baint ús&aacute;ide as do BBC iD',
            'signInText2': 'n&oacute;',
            'signInText3': 'Cl&aacute;raigh',
            'signInText4': 'T&aacute; s&eacute; simpl&iacute; agus saor.'
        }
    },
    'gd-gb': { //SCOTTISH
        'upsell': {
            'heading': 'Log a-steach agus cuir seo ri do Roghainnean',
            'text': 'Log a-steach agus cleachd do Roghainnean gus smachd a chumail air an stuth as fheàrr leat, air inneal sam bith.',
            'signIn': 'Log a-steach',
            'signInText1': ' le BBC iD',
            'signInText2': 'no',
            'signInText3': 'Cl&agrave;raich',
            'signInText4': 'Tha e luath is saor &rsquo;s an asgaidh.'
        }
    }
});

